import { Box } from "@mui/material";
import { H1 } from "@components";
import type { IWorkspace } from "features/workspaces/types";
import { Project } from "features/workspaces/components/Project";
import { DeleteWorkspaceButton } from "features/projects/components/DeleteWorkspaceButton";
import { workspaceStyle } from "./styles";

export const Workspace = ({ workspace }: { workspace: IWorkspace }) => (
  <Box sx={workspaceStyle}>
    <H1 label={workspace.name}>
      <DeleteWorkspaceButton id={workspace.id} />
    </H1>
    {workspace.projects.map(project => (
      <Project project={project} workspaceId={workspace.id} key={project.id} />
    ))}
  </Box>
);
